import Vue from 'vue'
import store from '@/store/store'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

// Проверяем роут на загрузку данных в стейт
const checkFavouritesGroupsLoaded = (to, from, next) => {
  if (store.state.favourites.favouriteGroups.length === 0) {
    store.watch(
      state => state.favourites.favouriteGroups,
      newValue => {
        if (newValue) next()
      }
    )
  } else {
    next()
  }
}

// Роуты
export default new Router({
  mode: 'history',
  scrollBehavior(to) {
    if (to.name === 'dashboard' || to.name === 'dashboardExtended') {
      return {}
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      props: true,
      components: {
        default: () => import('@/views/Dashboard.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
      children: [
        {
          name: 'index',
          path: '',
          props: true,
          components: {
            dashboard: () =>
              import('@/components/dashboards/DashboardPanel.vue'),
            dashboardOptions: () =>
              import('@/components/dashboards/DashboardOptions.vue'),
          },
        },
        {
          path: 'dashboard/:id',
          name: 'dashboard',
          props: true,
          components: {
            dashboard: () =>
              import('@/components/dashboards/DashboardPanel.vue'),
            dashboardOptions: () =>
              import('@/components/dashboards/DashboardOptions.vue'),
          },
        },
        {
          path: 'dashboard/:id/:extendedId',
          name: 'dashboardExtended',
          props: true,
          components: {
            dashboard: () =>
              import('@/components/dashboards/DashboardPanel.vue'),
            dashboardOptions: () =>
              import('@/components/dashboards/DashboardOptions.vue'),
          },
        },
      ],
    },
    {
      path: '/indicators',
      name: 'indicators',
      components: {
        default: () => import('@/views/Indicators.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
    },
    {
      path: '/constructor',
      name: 'constructor',
      components: {
        default: () => import('@/views/Constructor.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
    },
    {
      path: '/error',
      name: 'error',
      components: {
        default: () => import('@/views/Error.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
    },
    {
      path: '/indicator/:id',
      name: 'indicator',
      props: true,
      components: {
        default: () => import('@/views/Indicator.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
    },
    {
      path: '/user',
      props: true,
      components: {
        default: () => import('@/views/user/UserLayout.vue'),
        header: () => import('@/components/layout/Header.vue'),
        footer: () => import('@/components/layout/Footer.vue'),
      },
      beforeEnter(to, from, next) {
        if (localStorage.getItem('accessToken') !== null) {
          next()
        } else {
          next('/error')
        }
      },
      children: [
        {
          path: '',
          name: 'user',
          redirect: 'templates', //  временный редирект
          components: {
            user: () => import('@/views/user/User.vue'),
          },
        },
        {
          path: 'profile',
          name: 'profile',
          components: {
            user: () => import('@/views/user/Profile.vue'),
          },
        },

        {
          path: 'templates',
          components: {
            user: () => import('@/views/user/templates/TemplatesLayout.vue'),
          },
          children: [
            {
              path: '',
              name: 'templates',
              components: {
                templates: () => import('@/views/user/templates/Templates.vue'),
              },
            },
            {
              path: 'new',
              name: 'template.create',
              components: {
                templates: () => import('@/views/user/templates/Template.vue'),
              },
            },
            {
              path: ':id',
              name: 'template.view',
              props: true,
              components: {
                templates: () => import('@/views/user/templates/Template.vue'),
              },
            },
          ],
        },

        {
          path: 'documents',
          components: {
            user: () => import('@/views/user/documents/DocumentsLayout.vue'),
          },
          children: [
            {
              path: '',
              name: 'documents',
              components: {
                documents: () => import('@/views/user/documents/Documents.vue'),
              },
            },
            {
              path: 'new',
              name: 'document.create',
              components: {
                documents: () => import('@/views/user/documents/Document.vue'),
              },
            },
            {
              path: ':id',
              name: 'document.view',
              props: true,
              components: {
                documents: () => import('@/views/user/documents/Document.vue'),
              },
            },
          ],
        },

        {
          path: 'charts',
          components: {
            user: () => import('@/views/user/charts/UserChartsLayout.vue'),
          },
          children: [
            {
              path: '',
              name: 'charts',
              components: {
                charts: () => import('@/views/user/charts/UserCharts.vue'),
              },
            },
            {
              path: 'new',
              name: 'chart.create',
              components: {
                charts: () => import('@/views/user/charts/UserChart.vue'),
              },
            },
            {
              path: ':id',
              name: 'chart.view',
              props: true,
              components: {
                charts: () => import('@/views/user/charts/UserChart.vue'),
              },
            },
          ],
        },

        {
          path: 'favourites',
          name: 'favouritesList',
          components: {
            user: () => import('@/views/user/favourites/Favourites.vue'),
          },
        },

        {
          path: 'favourites/:id',
          name: 'favouritesGroup',
          props: true,
          beforeEnter: checkFavouritesGroupsLoaded,
          components: {
            user: () => import('@/views/user/favourites/Favourite.vue'),
          },
        },
      ],
    },
  ],
})
